import Immutable from 'immutable';
import moment from 'moment';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

// action creators
import { appointmentCreate } from '../../../actions/appointmentActions';
import { bookedAppointmentClear } from '../../../actions/bookedAppointmentActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';

// images
import successImage from '../../../assets/images/success.gif';
import {
  APPOINTMENT_ALREADY_BOOKED,
  APPOINTMENT_FREQUENCY_LIMIT,
  APPOINTMENT_REP_BLOCKED
} from '../../../constants/messages';
import CatererContactModal from '../../shared/modal/CatererContactModal';

class ConfirmBookAppointmentModal extends React.Component {
  static propTypes = {
    appointmentId:          PropTypes.string.isRequired,
    book:                   PropTypes.instanceOf(Immutable.Map),
    bookedAppointment:      PropTypes.instanceOf(Immutable.Map),
    clearBookedAppointment: PropTypes.func.isRequired,
    createAppointment:      PropTypes.func.isRequired,
    currentUser:            PropTypes.instanceOf(Immutable.Map),
    doctors:                PropTypes.instanceOf(Array),
    hideModal:              PropTypes.func.isRequired,
    id:                     PropTypes.string,
    scheduledOn:            PropTypes.instanceOf(moment),
    showModal:              PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.CATERER_MODAL_ID = `CatererContactModal_${this.props.scheduledOn.format()}_${Math.random()}`;
  }

  render() {
    const { id } = this.props;

    return (
      <Fragment>
        <Modal id={ id }>
          <div className='modal__header'>
            { this._getTitle() }
          </div>

          { this._renderBody() }

        </Modal>
        <CatererContactModal description='Or skip it for now.' id={ this.CATERER_MODAL_ID } onBack={ this._handleCatererModalClosing } onSuccess={ this._handleConfirm } />
      </Fragment>
    );
  }

  // private

  _handleCloseModal  = this._handleCloseModal.bind(this);
  _handleConfirm     = this._handleConfirm.bind(this);
  _handleCatererModalClosing     = this._handleCatererModalClosing.bind(this);
  _handleCatererModalOpening     = this._handleCatererModalOpening.bind(this);

  _getTitle() {
    const { bookedAppointment } = this.props;

    let title;

    if (bookedAppointment.get('status') === 'success') {
      title = 'You\'re all booked!';
    } else if (bookedAppointment.get('status')  === 'error') {
      title = this._bookingErrorCopy().header;
    } else {
      title = 'Are you sure?';
    }

    return title;
  }

  _handleCloseModal() {
    const { clearBookedAppointment, hideModal, id } = this.props;

    clearBookedAppointment();
    hideModal(id);
  }

  _handleConfirm() {
    const { appointmentId, createAppointment, currentUser, hideModal, showModal, id  } = this.props;

    const params = {
      appointmentId:  appointmentId,
      repId:          currentUser.get('data').get('id')
    };

    createAppointment(params);
    showModal(id);
    hideModal(this.CATERER_MODAL_ID);
  }

  _handleCatererModalOpening() {
    const { id, hideModal, showModal } = this.props;

    hideModal(id);
    showModal(this.CATERER_MODAL_ID);
  }

  _handleCatererModalClosing() {
    const { id, hideModal, showModal } = this.props;

    showModal(id);
    hideModal(this.CATERER_MODAL_ID);
  }

  _renderBody() {
    const { book, bookedAppointment, scheduledOn } = this.props;

    let element;

    if (bookedAppointment.get('status') === 'success') {
      element = (
        <div>
          <img className='rep-apts-index__book-modal__success-image' src={ successImage } />
          <div className='modal__actions'>
            <Button className='form__button form__button--green rep-apts-index__book-modal__button'
              onClick={ this._handleCloseModal }
              type='button'>
              Awesome!
            </Button>
          </div>
        </div>
      );
    } else if (bookedAppointment.get('status') === 'error') {
      element = (
        <div>
          {this._bookingErrorCopy().body}
          <div className='modal__actions'>
            <Button className='form__button form__button--green rep-apts-index__book-modal__button'
              onClick={ this._handleCloseModal }
              type='button'>
              Close
            </Button>
          </div>
        </div>
      );
    } else {
      element = (
        <div>
          <div>
            <div className='rep-apts-index__book-modal__row'>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                Date:
              </div>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--right rep-apts-index__book-modal__date'>
                { scheduledOn.format('MMM D, YYYY') }
              </div>
            </div>
            <div className='rep-apts-index__book-modal__row'>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                Time:
              </div>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--right'>
                { scheduledOn.format('h:mm a') }
              </div>
            </div>
            <div className='rep-apts-index__book-modal__row'>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                Location:
              </div>
              <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--right'>
                { book.get('name') }
              </div>
            </div>
            { this._renderDoctorsRow() }
          </div>
          <div className='modal__actions'>
            <Button className='form__button form__button--red rep-apts-index__book-modal__button'
              disabled={ bookedAppointment.get('loading') }
              onClick={ this._handleCloseModal }
              type='button'>
              Cancel
            </Button>
            <Button className='form__button form__button--green rep-apts-index__book-modal__button'
              loading={ bookedAppointment.get('loading') }
              onClick={ this._handleCatererModalOpening }
              type='button'>
              Confirm
            </Button>
          </div>
        </div>
      );
    }

    return element;
  }

  _renderDoctorsRow() {
    const { doctors } = this.props;

    const numberOfDoctors = doctors.length || 0;

    const element = (
      <div className='rep-apts-index__book-modal__row'>
        <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
          { pluralize('Doctor', numberOfDoctors) }:
        </div>
        <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--right'>
          { numberOfDoctors === 0 ? 'No doctors listed' : doctors.join(', ') }
        </div>
      </div>
    );

    return element;
  }

  _bookingErrorCopy() {
    const fallback = {
      header: 'Unable to book appointment',
      body: 'Something went wrong. Please try again.'
    };
    const error = this.props.bookedAppointment.get('error');

    if (!error) {
      return fallback;
    }

    const jsError = typeof error.toJS === 'function' ? error.toJS() : error;
    const details = jsError
      && jsError.response
      && jsError.response.body
      && jsError.response.body.details;

    if (!details || typeof details !== 'object') {
      return fallback;
    }

    return this._appointmentErrors(Object.keys(details)[0]) || fallback;
  }

  _appointmentErrors(type) {
    return {
      quarterlyAppointmentsLimit: {
        header: APPOINTMENT_FREQUENCY_LIMIT.header,
        body: APPOINTMENT_FREQUENCY_LIMIT.body
      },
      appointmentId: {
        header: APPOINTMENT_ALREADY_BOOKED.header,
        body: APPOINTMENT_ALREADY_BOOKED.body
      },
      blocked: {
        header: APPOINTMENT_REP_BLOCKED.header,
        body: APPOINTMENT_REP_BLOCKED.body
      }
    }[type];
  }
}

const mapStateToProps = (state) => {
  return {
    bookedAppointment: state.get('bookedAppointment'),
    currentUser:       state.get('currentUser')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearBookedAppointment: () => dispatch(bookedAppointmentClear()),
    createAppointment: (params) => dispatch(appointmentCreate(params)),
    hideModal: (id) => dispatch(tooltipHide({ id: id })),
    showModal: (id) => dispatch(tooltipShow({ id: id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmBookAppointmentModal);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_ConfirmBookAppointmentModal.jsx